// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"AwardsPage_toolbar__NJBbO","add":"AwardsPage_add__33xS6","table":"AwardsPage_table__jXyNM"};